import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICriticalError } from "@crunchit/types";
import { loadCategories } from "./thunks";
import { IMenuState } from "models/store";

/* Menu slice */

const initialState: IMenuState = {
  menuId: "",
  categories: [],
  isLoading: false,
};

export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<ICriticalError>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    resetError: (state) => {
      delete state.error;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(loadCategories.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(loadCategories.fulfilled, (state, action) => {
        const { menuId, categories } = action.payload;
        state.menuId = menuId; // Caching the menu id
        state.categories = categories;
        state.isLoading = false;
      });
  },
});

export const slice = menuSlice.reducer;
export const actions = menuSlice.actions;
